import {
  Card,
  Box,
  CardContent,
  CardActions,
  Skeleton
} from '@mui/material';

const SkeletonCardWithActions = () => {
  return (
    <Card sx={{ maxWidth: '220px', borderRadius: '12px' }}>
      <Box sx={{ m: 1 }}>
        {/* Skeleton image */}
        <Skeleton
          variant="rectangular"
          width="100%"
          height={140}
          sx={{ borderRadius: '12px' }}
        />

        <CardContent sx={{ px: 0, py: '16px' }}>
          <Skeleton variant="text" height={28} width="80%" />
          <Skeleton variant="text" height={20} width="60%" />
        </CardContent>

        <CardActions
          sx={{
            p: 0,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'nowrap',
            width: '100%',
          }}
        >
          {/* Left Side: Chip Placeholder */}
          <Skeleton
            variant="rectangular"
            width={60}
            height={24}
            sx={{ borderRadius: '12px', flexShrink: 1 }}
          />

          {/* Right Side: Edit/Delete Button Placeholders */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexShrink: 0,
              ml: 'auto',
            }}
          >
            <Skeleton
              variant="circular"
              width={36}
              height={36}
            />
            <Skeleton
              variant="circular"
              width={36}
              height={36}
              sx={{ ml: 1 }}
            />
          </Box>
        </CardActions>
      </Box>
    </Card>
  );
};

export default SkeletonCardWithActions;
